<dx-drop-down-box
    #dropDownBox
    width="100%"
    fieldTemplate="textFieldTemplate"
    contentTemplate="contentTemplate"
    valueExpr="context"
    displayExpr="title"
    [showClearButton]="false"
    [elementAttr]="elementAttr"
    [dropDownOptions]="{ width: 'auto' }"
    [readOnly]="readOnly"
    [disabled]="disabled"
    [(value)]="contextTreeBoxValue"
    [dataSource]="contextTreeDataSource"
    (onKeyUp)="onDropdownKeyUp($event)"
    (onOpened)="onDropdownOpen()"
    (onClosed)="onDropdownClosed()"
>
    <div *dxTemplate="let data of 'textFieldTemplate'" class="dropdown-textfield">
        <dx-text-box
            #dropDownBoxTextBox
            class="dropdown-textfield"
            [showClearButton]="showClearButton"
            [value]="textInputVal"
            [readOnly]="readOnly"
            [placeholder]="placeholder"
            (onEnterKey)="onTextEditorEnterKey()"
            (onInput)="onTextInput()"
            (onValueChanged)="onTextValueChange($event)"
        ></dx-text-box>
    </div>

    <div *dxTemplate="let data of 'contentTemplate'" class="context-tree-content">
        <dx-toolbar width="100%" class="icon-button-container">
            <dxi-item
                location="after"
                widget="dxButton"
                [options]="{
                    type: 'default',
                    stylingMode: 'text',
                    icon: 'far fa-plus-square',
                    hint: 'Expand All',
                    onClick: expandAllNodes
                }"
            ></dxi-item>
            <dxi-item
                location="after"
                widget="dxButton"
                [options]="{
                    type: 'default',
                    stylingMode: 'text',
                    icon: 'far fa-minus-square',
                    hint: 'Collapse All',
                    onClick: collapseAllNodes
                }"
            ></dxi-item>
        </dx-toolbar>
        <dx-tree-list
            *ngIf="showUserContextTree"
            height="100%"
            width="100%"
            class="help-content-tree cc-help-content-tree"
            keyExpr="context"
            parentIdExpr="parentContext"
            [autoNavigateToFocusedRow]="true"
            [focusedRowEnabled]="true"
            [showRowLines]="false"
            [showBorders]="false"
            [columnAutoWidth]="true"
            [showColumnHeaders]="false"
            [rootValue]="rootValue"
            [autoExpandAll]="autoExpandAll"
            [dataSource]="contextTreeDataSource"
            [(selectedRowKeys)]="contextTreeBoxValue"
            [focusedRowKey]="focusedRowKey"
            (onRowPrepared)="onContextTreeRowPrepared($event)"
            (onRowClick)="onContextTreeRowClick($event)"
            (onSelectionChanged)="onContextTreeSelectionChanged($event)"
        >
            <dxo-selection [mode]="selectionMode" [recursive]="false"></dxo-selection>
            <dxo-scrolling
                mode="virtual"
                rowRenderingMode="virtual"
                [preloadEnabled]="true"
                [scrollByContent]="true"
                [scrollByThumb]="true"
                showScrollbar="always"
            ></dxo-scrolling>
            <dxo-search-panel [width]="200" placeholder="Search Content Tree..."></dxo-search-panel>
            <dxi-column dataField="title" caption="Content"></dxi-column>
        </dx-tree-list>

        <!-- Dummy and Workaround tree list to overcome performance issue-->
        <dx-tree-list
            *ngIf="!showUserContextTree"
            height="100%"
            width="100%"
            class="help-content-tree cc-help-content-tree"
            keyExpr="context"
            parentIdExpr="parentContext"
            [dataSource]="[]"
            [showRowLines]="false"
            [showBorders]="false"
            [autoExpandAll]="false"
            [columnAutoWidth]="true"
            [showColumnHeaders]="false"
        >
            <dxo-search-panel [width]="200" placeholder="Search Content Tree..."></dxo-search-panel>
            <dxi-column dataField="title" caption="Content"></dxi-column>
        </dx-tree-list>
    </div>
</dx-drop-down-box>
